import { render, staticRenderFns } from "./download-app.vue?vue&type=template&id=15a7c1c6&scoped=true&"
import script from "./download-app.vue?vue&type=script&lang=js&"
export * from "./download-app.vue?vue&type=script&lang=js&"
import style0 from "./download-app.vue?vue&type=style&index=0&id=15a7c1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7c1c6",
  null
  
)

export default component.exports